import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon-svg/source/校验.svg'
import _imports_1 from '@/assets/icon-svg/source/校验禁用.svg'


const _withScopeId = n => (_pushScopeId("data-v-767610bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terminal_list" }
const _hoisted_2 = { class: "screen" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "单品名称 / 编码", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "单品条形码", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "条形码唯一性", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "品类", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "品牌", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "数据校准状态", -1))
const _hoisted_9 = { class: "searchBox" }
const _hoisted_10 = { style: {"margin-top":"20px","background":"#fff","padding":"0 30px 20px","border-radius":"4px"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_12 = { style: {"margin-bottom":"20px","display":"flex","justify-content":"space-between","align-items":"center","height":"50px","box-shadow":"inset 0px -1px 0px 0px rgba(232, 232, 232, 1)"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "moduleTitle" }, "单品列表", -1))
const _hoisted_14 = { style: {"display":"flex"} }
const _hoisted_15 = {
  key: 0,
  class: "spaceAroundBtn"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "刷新", -1))
const _hoisted_17 = { class: "batch" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "密度", -1))
const _hoisted_19 = { class: "SettingOutlinedBox" }
const _hoisted_20 = { class: "tableBox" }
const _hoisted_21 = { class: "serialNumber" }
const _hoisted_22 = { class: "terminalNameContainer" }
const _hoisted_23 = { class: "iconbox" }
const _hoisted_24 = { href: "javascript:" }
const _hoisted_25 = { class: "terminalNameBox longBox" }
const _hoisted_26 = ["title", "onClick"]
const _hoisted_27 = ["title"]
const _hoisted_28 = ["title"]
const _hoisted_29 = { class: "buttonBox" }
const _hoisted_30 = {
  key: 0,
  src: _imports_0,
  alt: "",
  style: {"margin-right":"1px","position":"relative","top":"3px"}
}
const _hoisted_31 = {
  key: 1,
  src: _imports_1,
  alt: "",
  style: {"margin-right":"1px","position":"relative","top":"3px"}
}
const _hoisted_32 = { style: {"display":"flex","justify-content":"space-between","margin-top":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Col = _resolveComponent("Col")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Cascader = _resolveComponent("Cascader")!
  const _component_Row = _resolveComponent("Row")!
  const _component_SearchOutlined = _resolveComponent("SearchOutlined")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SyncOutlined = _resolveComponent("SyncOutlined")!
  const _component_FileAddFilled = _resolveComponent("FileAddFilled")!
  const _component_ReloadOutlined = _resolveComponent("ReloadOutlined")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_ColumnHeightOutlined = _resolveComponent("ColumnHeightOutlined")!
  const _component_TagsFilled = _resolveComponent("TagsFilled")!
  const _component_Image = _resolveComponent("Image")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_PreviewModal = _resolveComponent("PreviewModal")!
  const _component_CheckModal = _resolveComponent("CheckModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Row, null, {
        default: _withCtx(() => [
          _createVNode(_component_Col, {
            span: 4,
            class: "terminal_name"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(_component_Input, {
                value: _ctx.spNameOrSpCode,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.spNameOrSpCode) = $event)),
                placeholder: "请输入...",
                onKeyup: _withKeys(_ctx.search, ["enter"]),
                allowClear: ""
              }, null, 8, ["value", "onKeyup"])
            ]),
            _: 1
          }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, {
            span: 4,
            class: "terminal_name"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createVNode(_component_Input, {
                value: _ctx.spBarCode,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.spBarCode) = $event)),
                placeholder: "请输入...",
                onKeyup: _withKeys(_ctx.search, ["enter"]),
                allowClear: ""
              }, null, 8, ["value", "onKeyup"])
            ]),
            _: 1
          }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, { span: 4 }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createVNode(_component_Select, {
                placeholder: "请选择",
                style: {"width":"100%"},
                value: _ctx.spBarStatus,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.spBarStatus) = $event)),
                options: _ctx.spBarStatusOptions,
                allowClear: ""
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, { span: 4 }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createVNode(_component_Cascader, {
                popupClassName: "popupClassName",
                style: {"width":"100%"},
                value: _ctx.categoryName,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.categoryName) = $event)),
                options: _ctx.categoryOptions,
                placeholder: "请选择...",
                "load-data": _ctx.loadDataCategory,
                "change-on-select": "",
                allowClear: ""
              }, null, 8, ["value", "options", "load-data"])
            ]),
            _: 1
          }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, { span: 4 }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createVNode(_component_Cascader, {
                popupClassName: "popupClassName",
                style: {"width":"100%"},
                onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getBrandList())),
                value: _ctx.brandName,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.brandName) = $event)),
                options: _ctx.brandOptions,
                placeholder: "请选择...",
                "change-on-select": "",
                showSearch: "",
                allowClear: ""
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_Row, null, {
        default: _withCtx(() => [
          _createVNode(_component_Col, { span: 4 }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createVNode(_component_Select, {
                placeholder: "请选择",
                style: {"width":"100%"},
                value: _ctx.checkStatus,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.checkStatus) = $event)),
                options: _ctx.checkStatusOptions,
                allowClear: ""
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, { span: 4 }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, { span: 4 }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, { span: 4 }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, {
            span: 4,
            class: "searchBoxfather"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Button, {
                  type: "primary",
                  onClick: _ctx.search
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SearchOutlined, { style: {"font-size":"14px","position":"relative","top":"1px"} }),
                    _createTextVNode("搜索")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  style: {"margin-left":"10px","border-color":"#008bcf","color":"#008bcf"},
                  onClick: _ctx.reset
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SyncOutlined, { style: {"font-size":"14px","position":"relative","top":"1px"} }),
                    _createTextVNode("重置")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_Button, {
            type: "primary",
            style: {"margin":"0 0 0 12px"},
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.terminalDetails())),
            class: "spaceAroundBtn"
          }, {
            default: _withCtx(() => [
              (_ctx.$store.state.authc.authc.ButtonBasic_pg_basiData_singleProductList_add)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_component_FileAddFilled),
                    _createTextVNode(" 新建")
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_Popover, null, {
            content: _withCtx(() => [
              _hoisted_16
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "SettingOutlinedBox",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
              }, [
                _createVNode(_component_ReloadOutlined)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Popover, {
            trigger: "click",
            placement: "bottom"
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", {
                  class: _normalizeClass(this.batchStyle == 'default' ? 'active' : ''),
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.batchStyle = 'default'))
                }, " 宽松 ", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(this.batchStyle == 'middle' ? 'active' : ''),
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.batchStyle = 'middle'))
                }, " 默认 ", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(this.batchStyle == 'small' ? 'active' : ''),
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.batchStyle = 'small'))
                }, " 紧凑 ", 2)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Popover, null, {
                content: _withCtx(() => [
                  _hoisted_18
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_ColumnHeightOutlined)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_Table, {
          rowKey: "id",
          columns: _ctx.columns,
          "data-source": _ctx.data,
          pagination: false,
          scroll: _ctx.scroll,
          loading: _ctx.loading,
          size: _ctx.batchStyle
        }, {
          serialNumber: _withCtx(({ index }) => [
            _createElementVNode("span", _hoisted_21, _toDisplayString(index + 1), 1)
          ]),
          spName: _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("a", _hoisted_24, [
                  _createVNode(_component_TagsFilled)
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("a", {
                    href: "javascript:",
                    class: "terminalName",
                    title: record.spName,
                    onClick: ($event: any) => (_ctx.terminalDetails(record.spBarCode))
                  }, _toDisplayString(record.spName), 9, _hoisted_26)
                ]),
                _createElementVNode("div", {
                  class: "terminalNameBox longBox",
                  style: {"color":"#ccc"},
                  title: record.spCode
                }, _toDisplayString(record.spCode), 9, _hoisted_27)
              ])
            ])
          ]),
          spBarCode: _withCtx(({ record }) => [
            _createElementVNode("div", {
              class: "terminalNameBox",
              title: record.spBarCode
            }, [
              _createElementVNode("span", null, _toDisplayString(record.spBarCode), 1)
            ], 8, _hoisted_28)
          ]),
          salesPrice: _withCtx(({ record }) => [
            _createTextVNode(_toDisplayString(_ctx.checkPrice(record.salesPrice) != "0.00"
                ? _ctx.checkPrice(record.salesPrice)
                : ""), 1)
          ]),
          spImage: _withCtx(({ record }) => [
            (_ctx.computedImgurl(record))
              ? (_openBlock(), _createBlock(_component_Image, {
                  key: 0,
                  style: {"width":"40px","height":"40px","object-fit":"cover"},
                  src: record.imgUrl
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ]),
          packageSize: _withCtx(({ record }) => [
            _createTextVNode(_toDisplayString(record.size), 1)
          ]),
          status: _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_Switch, {
                onChange: ($event: any) => (_ctx.disableSingleProductById(record.id, record.status)),
                checked: _ctx.computeStatus(record.status),
                size: "small",
                disabled: !_ctx.$store.state.authc.authc.ButtonBasic_pg_basiData_singleProductList_state
              }, null, 8, ["onChange", "checked", "disabled"])
            ])
          ]),
          only: _withCtx(({ record }) => [
            _createTextVNode(_toDisplayString(record.spBarStatus == 2 ? "不唯一" : "唯一"), 1)
          ]),
          handle: _withCtx(({ record }) => [
            _createVNode(_component_Button, {
              type: "link",
              disabled: record.spBarStatus != 2 || !_ctx.$store.state.authc.authc.ButtonBasic_pg_basiData_singleProductList_check,
              style: {"display":"flex","align-items":"center"},
              onClick: ($event: any) => (_ctx.calibration(record))
            }, {
              default: _withCtx(() => [
                (record.spBarStatus == 2 && _ctx.$store.state.authc.authc.ButtonBasic_pg_basiData_singleProductList_check)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_30))
                  : (_openBlock(), _createElementBlock("img", _hoisted_31)),
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: (record.spBarStatus != 2|| !_ctx.$store.state.authc.authc.ButtonBasic_pg_basiData_singleProductList_check) ? '#ccc' : '#008BCF' })
                }, _toDisplayString(record.checkStatus == 2 ? "已校准" : "校准"), 5)
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"])
          ]),
          _: 1
        }, 8, ["columns", "data-source", "scroll", "loading", "size"])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", null, " 共 " + _toDisplayString(_ctx.total) + " 条数据 ", 1),
        _createVNode(_component_Pagination, {
          "show-size-changer": "",
          "show-quick-jumper": "",
          current: _ctx.pageCurrent,
          "onUpdate:current": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.pageCurrent) = $event)),
          pageSize: _ctx.pageSize,
          "onUpdate:pageSize": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.pageSize) = $event)),
          total: _ctx.total,
          onShowSizeChange: _ctx.onShowSizeChange,
          "page-size-options": ['10', '20', '50', '100']
        }, null, 8, ["current", "pageSize", "total", "onShowSizeChange"])
      ])
    ]),
    _createVNode(_component_PreviewModal, { ref: "showPreModal" }, null, 512),
    _createVNode(_component_CheckModal, {
      ref: "CheckModal",
      onTodoTeload: _ctx.getTerminal
    }, null, 8, ["onTodoTeload"])
  ]))
}